// extracted by mini-css-extract-plugin
export var navContainer = "styles-module__navContainer___B0hib";
export var navBar = "styles-module__navBar____pygZ";
export var navAnchor = "styles-module__navAnchor___OndsG";
export var navTitle = "styles-module__navTitle___z7SiG";
export var tabBar = "styles-module__tabBar___pfR0B";
export var ctaButton = "styles-module__ctaButton___FOots";